const PRODUCT_LIKE_ENDPOINT = 'https://script.google.com/macros/s/AKfycbxAPiu8Q2QPWjVK26GhNaR1FILR9s822oYAqxZqHA0zmOPGlTANLSJ99dift8rnxGF7Kg/exec';

console.log('[product_like] script loaded');

const getLikeKey = (button) => {
  const productHandle = button.dataset.productHandle || 'unknown-product';

  return `product_like_${productHandle}`;
};

const markAsLiked = (button) => {
  setButtonLabel(button, 'love♥');
  button.disabled = true;
  button.setAttribute('aria-disabled', 'true');
  button.classList.add('is-liked');
};

const markAsUnliked = (button) => {
  setButtonLabel(button, 'love♡');
  button.disabled = false;
  button.removeAttribute('aria-disabled');
  button.classList.remove('is-liked');
};

const setButtonLabel = (button, text) => {
  const label = button.querySelector('.product-like-button__label');

  if (label) {
    label.textContent = text;
  } else {
    button.textContent = text;
  }
};

const getLocalStorageItem = (key) => {
  try {
    return window.localStorage.getItem(key);
  } catch (error) {
    return null;
  }
};

const setLocalStorageItem = (key, value) => {
  try {
    window.localStorage.setItem(key, value);
  } catch (error) {
    console.warn('[product_like] localStorage write failed:', error);
  }
};

const syncLikedState = (button) => {
  markAsUnliked(button);

  if (getLocalStorageItem(getLikeKey(button))) {
    markAsLiked(button);
  }
};

const syncAllLikedStates = () => {
  document.querySelectorAll('.product-like-button').forEach(syncLikedState);
};

const sendProductLike = (button) => {
  if (button.disabled) {
    console.log('[product_like] click ignored because button is disabled');
    return;
  }

  const likeKey = getLikeKey(button);

  if (getLocalStorageItem(likeKey)) {
    console.log('[product_like] already liked in this browser', { likeKey });
    markAsLiked(button);
    return;
  }

  const payload = {
    product_title: button.dataset.productTitle || '',
    product_handle: button.dataset.productHandle || '',
    page_url: window.location.href,
    user_agent: window.navigator.userAgent
  };

  console.log('[product_like] sending payload to GAS', {
    endpoint: PRODUCT_LIKE_ENDPOINT,
    payload
  });

  setLocalStorageItem(likeKey, '1');
  markAsLiked(button);

  try {
    fetch(PRODUCT_LIKE_ENDPOINT, {
      method: 'POST',
      mode: 'no-cors',
      body: JSON.stringify(payload)
    }).catch((error) => {
      console.warn('[product_like] request failed:', error);
    });
  } catch (error) {
    console.warn('[product_like] request failed:', error);
  }
};

const bindProductLikeButtons = () => {
  const buttons = document.querySelectorAll('.product-like-button');

  console.log('[product_like] found buttons', buttons.length);

  buttons.forEach((button) => {
    if (button.dataset.productLikeBound === 'true') {
      return;
    }

    button.dataset.productLikeBound = 'true';
    syncLikedState(button);
    button.addEventListener('click', () => sendProductLike(button));
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bindProductLikeButtons);
} else {
  bindProductLikeButtons();
}

window.addEventListener('popstate', syncAllLikedStates);

const originalPushState = window.history.pushState;
window.history.pushState = function (...args) {
  originalPushState.apply(this, args);
  syncAllLikedStates();
};

const originalReplaceState = window.history.replaceState;
window.history.replaceState = function (...args) {
  originalReplaceState.apply(this, args);
  syncAllLikedStates();
};

document.addEventListener('variant:change', () => {
  window.setTimeout(syncAllLikedStates, 0);
});
